/**
 * Get Domain Query
 * 
 * Query for retrieving domain information for read operations.
 */

import { IQuery, BaseQuery, IPaginatedResult } from '@swoft/core';

export interface DomainDto {
  domainId: string;
  name: string;
  description?: string;
  vision?: string;
  ubiquitousLanguage: Record<string, string>;
  createdAt: Date;
  updatedAt: Date;
}

export class GetDomainQuery extends BaseQuery<DomainDto> {
  constructor(
    public readonly domainId: string,
    authSessionId: string,
    initiatedByPersonId: string,
    correlationId?: string
  ) {
    super(authSessionId, initiatedByPersonId, correlationId);
  }
}

export interface ListDomainsParams {
  page?: number;
  pageSize?: number;
  searchTerm?: string;
  includeArchived?: boolean;
}

export class ListDomainsQuery extends BaseQuery<IPaginatedResult<DomainDto>> {
  constructor(
    public readonly params: ListDomainsParams,
    authSessionId: string = 'system',
    initiatedByPersonId: string = 'system',
    correlationId?: string
  ) {
    super(authSessionId, initiatedByPersonId, correlationId);
  }
}